module.exports = __webpack_public_path__ + "img/header-weddingRingsGold@2x.f0e19bb.jpg";